import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { error, openNotification, success, warning } from "swfrontend/COMS/NotificationMessageMapping";
import ListFooter from "swfrontend/MDM/MDMScreens/ListView/ListFooter.js";
import { route_url } from "swfrontend/AppConfigs";
import {
  notificationMessage,
  openNotificationType,
  notificationTitle,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import MaterialListCellButton from "../../MaterialTracking/Screens/AllMaterial/Components/MaterialListCellButton";
import { ACTIVITY_MODEL, DPR_APP, DPR_LIST_COLUNMN_DEFS, DPR_MODEL, NOTIFICATION_MEESAGES } from "../Constants";
import { DataProvider } from "../DataProvider";
import { excel_export_api_call } from "swfrontend/COMS/Utils/ApiCommunicaton";
import { CREATE_EXCEL_DATA } from "../../MaterialTracking/Helper";
import { fileDownloadHelper } from "../Helper";
import CustomListHeader from "./components/CustomListHeader";


let gridApi = null;
const dataProvider = new DataProvider();
const onGridReady = (params) => {
  gridApi = params.api;
};

const ProgressReport = ({ history }) => {
  const gridRef = useRef();
  const formRef = useRef();
  const [mstLocation, setMstLocation] = useState([]);
  const [mstProgram, setMstProgram] = useState([]);
  const [mstProject, setMstProject] = useState([]);
  const [state, setState] = useState({
    selectedRow: null,
    rowData: null,
    pageSize: 20,
    searchQuery: null,
    filterQuery: null,
    total: 0,
    currentPage: 1,
    customFilterQuery: null
  });

  const masterDataMapping = {
    "MstLocation": setMstLocation,
    "MstProgram": setMstProgram,
    "MstProject": setMstProject,
  };

  useEffect(() => {
    fetchDropdownValues();
  }, []);

  useEffect(() => {
    fetchGridData(state.currentPage);
  }, [state.currentPage, state.pageSize, state.searchQuery, state.filterQuery, state.customFilterQuery]);

  const fetchDropdownValues = () => {
    ['MstLocation', 'MstProject', 'MstProgram'].forEach((model, index) => {
      dataProvider.getDropdownValues(model)
        .then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    const setter = masterDataMapping[model];
                    setter(data.results)
                })
            } else {
                response.json().then((responseJson) => {
                    openNotification("error", "Error", responseJson["message"]);
                });
            }
        }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
    })
  }

  const fetchDependentDropdownValues = (model, filter, value, callback) => {
      // setShowEditProgress(true);
      dataProvider.getDependentDropdownValues(model, filter + value).then((response) => {
          if (response.ok) {
              response.json().then((data) => {
                  const setter = masterDataMapping[model];
                  setter(data.results)
                  callback(value)
              })
          } else {
              response.json().then((responseJson) => {
                  openNotification("error", "Error", responseJson["message"]);
              });
          }
      });
  };
  
  const onPaginationChange = (page, pageSize) => {
    if (page === 0 || page === null) {
      page = 1;
    }
    gridApi.showLoadingOverlay();
    setState({ ...state, pageSize: pageSize, currentPage: page });
  };

  const onSelectionChanged = () => {
    let selectedRows = gridApi.getSelectedRows();
    setState({ ...state, selectedRow: selectedRows });
  };

  const fetchGridData = (pageNo) => {
    let values = "";
    if (pageNo !== null) {
      values = "?page=" + pageNo;
    }

    if (state.pageSize !== null) {
      values += "&pageSize=" + state.pageSize;
    }

    if (state.searchQuery !== null) {
      values += "&" + state.searchQuery;
    }

    if (state.customFilterQuery !== null) {
      values += state.customFilterQuery;
    }

    if (state.filterQuery !== null) {
      values += "&" + state.filterQuery;
    }

    if (state.filterQuery !== null || state.customFilterQuery !== null) {
      values += "&filter=1";
    }

    dataProvider
      .getProgressList(values)
      .then((res) => {
        if (res.ok) {
          res.json().then((rowData) => {
            try {
              gridApi.hideOverlay();
            } catch (e) {}
            setState({
              ...state,
              total: rowData.total,
              rowData: rowData.results,
            });
          });
        } else {
          res.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch(() => {
        openNotification(
          openNotificationType.error,
          notificationTitle.api,
          notificationMessage.apiConnectionError
        );
      });
  };

  const handleExcelExport = () => {
    if (state.selectedRow == null || state.selectedRow.length === 0) {
      excelDownload("all");
    } else {
      excelDownload(null);
    }
  };

  const excelDownload = (allExport) => {
    let data = CREATE_EXCEL_DATA(
      allExport,
      state.searchQuery,
      state.filterQuery,
      state.selectedRow
    );
    allExport
      ? warning(NOTIFICATION_MEESAGES.WARNNIG_ALL_EXCEL_EXPORT)
      : warning(NOTIFICATION_MEESAGES.WARNNIG_SELECTED_EXCEL_EXPORT);
    excel_export_api_call(DPR_APP, ACTIVITY_MODEL, data).then((res) => {
      if (res.ok) {
        if (res.status === 204) {
          success(NOTIFICATION_MEESAGES.SUCCESS_EMAIL_EXCEL_EXPORT);
        } else {
          res.blob().then((blob) => {
            fileDownloadHelper(blob, 'ProgressData.xlsx');
            setState({ ...state, selectedRow: null });
          });
          success(NOTIFICATION_MEESAGES.SUCCESS_EXCEL_EXPORT);
        }
      } else {
        error(NOTIFICATION_MEESAGES.ERROR_EXCEL_EXPORT);
      }
    });
  };

  const cellLinkButtonClick = (e) => {
    history.push(route_url.url + "/ViewProgress/" + e.progress.id);
  };

  const handleNewButtonClick = () => {
    history.push(route_url.url + "/NewProgress");
  };

  const handleFilterApply = (querystring) => {
    gridApi.showLoadingOverlay();
    setState({ ...state, filterQuery: querystring, currentPage: 1 });
  };

  const handleResetFilter = () => {
    gridApi.showLoadingOverlay();
    setState({
      ...state,
      filterQuery: null,
      currentPage: 1,
    });
  };

  const handleResetSearch = () => {
    gridApi.showLoadingOverlay();
    setState({ ...state, searchQuery: null });
  };

  const handleSearchApply = (value) => {
    gridApi.showLoadingOverlay();
    let quer_param = "search=" + value;
    if (value === "") {
      quer_param = null;
    }
    setState({ ...state, searchQuery: quer_param, currentPage: 1 });
  };

  let gridHeight = window.innerHeight - 300 + "px";
  DPR_LIST_COLUNMN_DEFS.map((column, index) => {
    if (["id"].includes(column.field)) {
      column["cellRendererParams"] = {
        cellLinkButtonClick: cellLinkButtonClick,
      };
    }
  });

  const excelImport = (file) => {
    warning("Please wait while excel data is added/updated");
    let formData = new FormData();
    formData.append("excel_file", file);

    dataProvider.importProgress(formData)
    .then((res) => {
      if (res.ok) {
        res.blob().then((blob) => {
          fileDownloadHelper(blob, "ImportResults.xlsx");
          gridApi.showLoadingOverlay();
          setState({ ...state, currentPage: 1 });
          fetchGridData(1);
          success("Excel Imported ! Please review the downloaded sheet for import details");
        });
      } else {
        return res.json().then((res) => {
          openNotification('error', 'Error importing progress data');
        });
      }
    })
  }

  // const onChangeMonthFilter = (date) => {
  //   setState({
  //     monthFilter: date ? moment(date, 'YYYY-MM') : null,
  //   });

  //   // gridApi.showLoadingOverlay();
  //   // setState({
  //   //   ...state,
  //   //   currentPage: 1,
  //   //   monthFilter: date ? moment(date, 'YYYY-MM') : null,
  //   // });
  // }

  let grid = (
    <AgGridReact
      ref={gridRef}
      columnDefs={DPR_LIST_COLUNMN_DEFS}
      rowData={state.rowData}
      pagination={false}
      onGridReady={onGridReady}
      onSelectionChanged={onSelectionChanged}
      frameworkComponents={{
        MaterialListCellButton,
      }}
    ></AgGridReact>
  );

  const downloadTemplate = () => {
    dataProvider.downloadImportTemplate().then((res) => {
      if (res.ok) {
          res.blob().then((blob) => {
            fileDownloadHelper(blob, 'progress-data-import-template.xlsx');
          });
          success(NOTIFICATION_MEESAGES.SUCCESS_TEMPLATE_EXPORT);
      } else {
        error(NOTIFICATION_MEESAGES.ERROR_TEMPLATE_EXPORT);
      }
    });
  }

  const applyFilter = (values) => {
    let filterString = "";

    Object.keys(values).forEach(key => {
      if(key == 'month' && values[key]) {
        const lastDayOfMonth = values[key].endOf('month').format('DD');
        filterString += `&progress.activity_month=after_${values[key].format('YYYY-MM')}-01&progress.activity_month=before_${values[key].format('YYYY-MM')}-${lastDayOfMonth}`    
      } else if (values[key]) {
        filterString += `&progress.${key}.name=${values[key]}`
      } 
      // else if (key == 'stream' && values[key]) {
      //   filterString += `&progress.${key}.program_id=${values[key]}`
      // } else if (key == 'project' && values[key]) {
      //   filterString += `&progress.${key}.project_id=${values[key]}`
      // }
    });

    gridApi.showLoadingOverlay();
    setState({
      ...state,
      currentPage: 1,
      customFilterQuery: filterString,
    });
  };

  return (
    <div className="col-md-12">
      
      <CustomListHeader
        formRef={formRef}
        mstLocation={mstLocation}
        mstProject={mstProject}
        mstProgram={mstProgram}
        downloadTemplate={downloadTemplate}
        excelExport={() => handleExcelExport()}
        showListHeader={true}
        addButton={true}
        columnFilterButton={false}
        columnDefs={DPR_LIST_COLUNMN_DEFS}
        onSearch={(q) => handleSearchApply(q)}
        onFilter={(q) => handleFilterApply(q)}
        onResetSearch={() => handleResetSearch()}
        onResetFilter={() => handleResetFilter()}
        addField={handleNewButtonClick}
        excelImport={excelImport}
        applyFilter={applyFilter}
        // monthFilter={state.monthFilter}
        // onChangeMonthFilter={onChangeMonthFilter}
        fetchDependentDropdownValues={fetchDependentDropdownValues}
      />
      <div className="grid-background">
        <div className="row">
          <div className="col-md-12">
            <div
              id="grid"
              className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
              style={{ height: gridHeight }}
            >
              {grid}
            </div>
          </div>
        </div>
      </div>
      <div>
        <ListFooter
          total={state.total}
          currentPage={state.currentPage}
          onShowSizeChange={(pageNo, pageSize) =>
            onPaginationChange(pageNo, pageSize)
          }
          onPaginationChange={(pageNo, pageSize) =>
            onPaginationChange(pageNo, pageSize)
          }
        />
      </div>
    </div>
  );
};

export default ProgressReport;
